var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegionPinAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22,12.477v3.523h-6.086l-5.914-5.914V2h1.865c.347-.656.793-1.264,1.333-1.804.069-.069.145-.13.216-.196H3C1.346,0,0,1.346,0,3v21h24v-13.415c-.067.072-.128.148-.198.218l-1.802,1.673ZM3,2h5v7.9l-6,3.199V3c0-.552.449-1,1-1Zm-1,13.367l6.817-3.636,5.363,5.363-3.679,4.906H2v-6.633Zm11,6.633l3-4h6v4h-9Zm4-16.494c0-.828.672-1.5,1.5-1.5s1.5.672,1.5,1.5-.672,1.5-1.5,1.5-1.5-.672-1.5-1.5Zm-2.351,3.92l3.851,3.572,3.889-3.609c1.039-1.038,1.611-2.419,1.611-3.889s-.572-2.851-1.611-3.889c-1.038-1.039-2.419-1.611-3.889-1.611s-2.851.572-3.889,1.611c-1.039,1.038-1.611,2.419-1.611,3.889s.576,2.854,1.649,3.926Zm1.376-6.4c.661-.661,1.539-1.025,2.475-1.025s1.813.364,2.475,1.025,1.025,1.539,1.025,2.475-.364,1.813-.998,2.448l-2.502,2.321-2.464-2.284c-.668-.668-1.036-1.55-1.036-2.485s.364-1.813,1.025-2.475Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegionPinAlt);
export default __webpack_public_path__ + "static/media/region-pin-alt.98bf5d408fdacd026da069e03574ca75.svg";
export { ForwardRef as ReactComponent };